<template>
  <div
    class="summary"
    :title="local.calendar.showSessionDetails"
  >
    <v-menu :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            v-if="session.isVideoConference"
            class="ma-0 pa-0"
            color="deep-purple accent-3"
            left
          >
            mdi-microsoft-teams
          </v-icon>
          <v-icon
            v-else
            color="var(--app-primary-color)"
            class="ma-0 pa-0"
            left
          >
            mdi-map-marker
          </v-icon>
          <v-icon
            small
            class="icon ma-0"
            color="#A6B8BB"
          >
            mdi-clock-outline
          </v-icon>
          <strong class="px-1">{{ getTimeSlot(session.appointmentStartDate,session.appointmentEndDate) }}</strong>
          <span>{{ local.calendar.caseCode }}</span>
          <strong class="px-1">{{ session.caseCode }}</strong>
          <span>{{ local.calendar.sessionType }}</span>
          <strong class="px-1">{{ session.sessionType }}</strong>
        </div>
      </template>
      <calendar-session-card
        :session="session"
        :case-object-key="session.caseObjectKey"
        :is-pega="session.isPega"
        :court-id="session.courtId"
      ></calendar-session-card>
    </v-menu>
  </div>
</template>

<script>
import { toHijriDate, getTimeSlot, getTimePart } from '@/helpers/utils';

import CalendarSessionCard from './calendar-session-card.vue';

export default {
  name: 'SessionSummary',
  components: { CalendarSessionCard },
  props: {
    session: {
      type: Object,
      required: true,
    },
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: [String, Boolean],
      required: true,
    },
    courtId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    toHijriDate,
    getTimeSlot,
    getTimePart,
  },
};
</script>

<style scoped>
.summary {
  white-space: normal;
}
</style>
